import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabase';
import './Admin.css';

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  return (
    <div className="admin-container">
      <aside className="admin-sidebar">
        <h2>
          <img src="/Images/paoz.png" alt="PAOZ HCC Logo" className="admin-logo" />
          <span>HCC Admin</span>
        </h2>
        <nav className="admin-nav">
          <Link to="/admin">Dashboard</Link>
          <Link to="/admin/events">Manage Events</Link>
          <Link to="/admin/announcements">Announcements</Link>
          <Link to="/admin/sermon">Latest Sermon</Link>
        </nav>
        <button onClick={handleLogout} className="admin-logout-btn">Log out</button>
      </aside>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
